export default "__VITE_ASSET__Rco4VFkP__"